import { atom, Getter, Setter } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { ShoppingCartItem } from "../../api/productTransactions/models";
import { LOCAL_STORAGE_KEYS } from "../../constants/localstorageConstants";
import { selectedFeaturedBundleIndexAtom } from "../profileScreen/artistReleaseTabView";

const _productCartAtom = atomWithStorage<ShoppingCartItem[]>(
  LOCAL_STORAGE_KEYS.PRODUCT_SHOPPING_CART,
  [],
);

const productCartGetter = (get: Getter) => {
  return get(_productCartAtom);
};

const productCartSetter = (
  _: Getter,
  set: Setter,
  selectedCartItem: ShoppingCartItem[],
) => {
  // If the cart is being cleared, then we don't want to select any specific product, which returns the user back to the previous view?
  // TODO: Move the releases to a routing system and navigate the user instead of clearing the atom.
  if (!selectedCartItem) {
    set(selectedFeaturedBundleIndexAtom, "");
  }
  set(_productCartAtom, selectedCartItem);
};

export const productCartAtom = atom(productCartGetter, productCartSetter);

productCartAtom.debugLabel = "Product Shopping Cart";
